'use strict'

export const sizes = [
  'tiny',
  'small',
  'default',
  'big',
  'large',
  'huge',
  'gigantic',
]

export const icons = [
  'duckduckgo',
  'tiktok',
  'gmail',
  'neutral-outline',
  'history',
  'input-text',
  'input-textarea',
  'shield',
  'rocket',
  'clone',
  'table',
  'undo',
  'kanban',
  'infinite',
  'gears',
  'leads-outline',
  'leads',
  'align-center',
  'align-left',
  'align-right',
  'button',
  'editor-background',
  'editor-banner',
  'form',
  'editor-general',
  'editor-header',
  'editor-layout',
  'font',
  'organisation',
  'track',
  'alert-circled',
  'alert',
  'android-add-circle',
  'android-add',
  'android-alarm-clock',
  'android-alert',
  'grid',
  'android-archive',
  'android-arrow-dropdown',
  'android-arrow-dropleft',
  'android-arrow-dropright',
  'android-arrow-dropup',
  'android-attach',
  'android-bookmark',
  'bulb',
  'android-camera',
  'android-cancel',
  'android-chat',
  'checkbox',
  'android-cloud-done',
  'android-cloud-outline',
  'android-cloud',
  'color-palette',
  'android-create',
  'document-solid',
  'done-all',
  'download',
  'mail-open',
  'android-exit',
  'heart-outline',
  'heart',
  'film',
  'folder',
  'folder-open',
  'funnel-b',
  'android-image',
  'list-form',
  'locate',
  'mail',
  'android-map',
  'list',
  'more-horizontal',
  'more-vertical',
  'notifications-outline',
  'notifications-off',
  'notifications',
  'open',
  'pin',
  'radio-button',
  'share-alt',
  'star-half',
  'star-outline',
  'star',
  'stopwatch',
  'sync',
  'time',
  'walk',
  'warning',
  'aperture',
  'archive',
  'arrow-down-a',
  'arrow-down-b',
  'arrow-down-c',
  'arrow-expand',
  'arrow-graph-down-left',
  'arrow-graph-down-right',
  'arrow-graph-up-left',
  'arrow-graph-up-right',
  'arrow-left-a',
  'arrow-left-b',
  'arrow-left-c',
  'arrow-move',
  'arrow-resize',
  'arrow-return-left',
  'arrow-return-right',
  'arrow-right-a',
  'arrow-right-b',
  'arrow-right-c',
  'arrow-shrink',
  'arrow-swap',
  'arrow-up-a',
  'arrow-up-b',
  'arrow-up-c',
  'at',
  'backspace-outline',
  'backspace',
  'bookmark',
  'briefcase',
  'bug',
  'calculator',
  'calendar',
  'camera',
  'card',
  'chatbox-working',
  'chatbox',
  'chatboxes',
  'chatbubble-working',
  'chatbubble',
  'chatbubbles',
  'checkmark',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'clipboard',
  'clock',
  'close-circled',
  'close',
  'cloud',
  'code-download',
  'code-working',
  'code',
  'compose',
  'connection-bars',
  'contrast',
  'crop',
  'cube',
  'disc',
  'document-text',
  'document',
  'drag',
  'globe',
  'edit',
  'egg',
  'erlenmeyer-flask',
  'eye-disabled',
  'eye',
  'filing',
  'film-marker',
  'fireball',
  'flag',
  'flash-off',
  'flash',
  'branch-new',
  'forward',
  'funnel',
  'gear-a',
  'cog',
  'gear-b',
  'happy-outline',
  'happy',
  'help-buoy',
  'help-circled',
  'help',
  'home',
  'image',
  'images',
  'information-circled',
  'information',
  'ios-paper',
  'people',
  'pulse',
  'ipad',
  'iphone',
  'key',
  'laptop',
  'leaf',
  'levels',
  'lightbulb',
  'link',
  'location',
  'locked',
  'log-in',
  'log-out',
  'loop',
  'man',
  'merge',
  'minus-circled',
  'minus',
  'monitor',
  'mouse',
  'navicon-round',
  'navicon',
  'navigate',
  'network',
  'paintbrush',
  'paintbucket',
  'paper-airplane',
  'paperclip',
  'pause',
  'person-add',
  'person-stalker',
  'person',
  'pie-graph',
  'plus-circled',
  'plus',
  'podium',
  'pound',
  'pricetag',
  'pricetags',
  'printer',
  'qr-scanner',
  'quote',
  'refresh',
  'reply-all',
  'reply',
  'sad-outline',
  'sad',
  'search',
  'settings',
  'share',
  'shuffle',
  'social-android',
  'social-apple',
  'social-facebook',
  'facebook',
  'social-foursquare',
  'foursquare',
  'social-github',
  'github',
  'social-google',
  'google',
  'social-googleplus',
  'social-instagram',
  'instagram',
  'social-linkedin',
  'linkedin',
  'social-pinterest',
  'pinterest',
  'social-rss',
  'social-skype',
  'social-snapchat',
  'snapchat',
  'social-tux',
  'social-twitch',
  'twitch',
  'social-twitter',
  'twitter',
  'social-vimeo',
  'vimeo',
  'social-whatsapp',
  'whatsapp',
  'social-windows',
  'social-youtube',
  'youtube',
  'soup-can',
  'speakerphone',
  'dashboard',
  'stats-bars',
  'steam',
  'thumbsdown',
  'thumbsup',
  'trash',
  'trophy',
  'unlocked',
  'upload',
  'wand',
  'wifi',
  'woman',
  'wrench',
  'play',
  'stop',
  'easel',
  'university',
  'bing',
  'social-messenger',
  'messenger',
  'spacer',
  'air-balloon',
  'zapier',
  'table1',
  'form-clone',
  'arrow-sort',
  'social-tumblr',
  'ad',
  'save',
  'safari',
  'chrome',
  'firefox',
  'opera',
  'internet-explorer',
  'edge',
  'circleqq',
  'circlerenren',
  'circletudou',
  'circlewechat',
  'circleweixin',
  'circletwitter',
  'circleweibo',
  'circlegoogleplus',
  'circlefoursquare',
  'circlepinterest',
  'circleinstagram',
  'circlewordpress',
  'circlechat',
  'circlecloud',
  'circleglobe',
  'circlesocialglobe',
  'circlemapmarker',
  'circlefacebook',
  'circlerss',
  'circlelinkedin',
  'circleyoutube',
  'circledribble',
  'circlebehance',
  'circleblogger',
  'circleflikr',
  'circletumblr',
  'circlevimeo',
  'circleyouku',
  'eraser',
]
